/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
export class Point {
  _x: number;

  _y: number;

  constructor(x = 0, y = 0, height = 170) {
    this._x = x;
    this._y = height - y;
  }
}

interface Vector {
  width: number;
  curve: Point[];
}

const getVectors: (count: number) => Vector[] = (count) => {
  const result = Array.from(Array(count).keys()).map((item) => ({
    curve: [
      new Point(item * 180, item % 2 ? 170 : 0),
      new Point(item * 180 + 90, item % 2 ? 170 : 0),
      new Point(item * 180 + 90, item % 2 ? 0 : 170),
      new Point(item * 180 + 180, item % 2 ? 0 : 170),
    ],
    width: 180,
  }));
  return result;
};

class BezierCurve {
  map: Point[];

  vectors: Vector[];

  constructor(count: number) {
    this.vectors = getVectors(count);
    this.map = this.createCoordenatesMap();
  }

  C = (n: number, k: number) => {
    let coeff = 1;
    for (let x = n - k + 1; x <= n; x++) {
      coeff *= x;
    }
    for (let x = 1; x <= k; x++) {
      coeff /= x;
    }
    return coeff;
  };

  getNewPoint = (t: number, points: Point[]) => {
    let x = 0;
    let y = 0;
    const n = 3;
    for (let i = 0; i <= n; i++) {
      const bin = this.C(n, i) * (1 - t) ** (n - i) * t ** i;
      x += bin * points[i]._x;
      y += bin * points[i]._y;
    }

    return new Point(x, y);
  };

  createCoordenatesMap = () => {
    const coor: Point[] = [];

    this.vectors.forEach((vector) => {
      let t = 0;
      for (let i = 0; i < vector.width; i++) {
        coor.push(this.getNewPoint(t, vector.curve));
        t += 1 / vector.width;
      }
    });
    return coor;
  };

  GetPoint = (x: number) => {
    const point = new Point();
    try {
      this.map.forEach((el) => {
        if (Math.abs(el._x - x) < 1) {
          point._x = el._x;
          point._y = el._y;
          throw new Error('break'); // if find, breaks foreach
        }
      });
    } catch (e) {
      /* empty */
    }
    return point;
  };
}

export default BezierCurve;
